import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface InitialState {
	isMessengerOpen: boolean;
}

interface Store extends InitialState {
	toggleMessenger: () => void;
}

const initialState: InitialState = {
	isMessengerOpen: false,
};

const appStore = create<Store>()(
	persist(
		(set, get) => {
			const toggleMessenger = () => {
				const { isMessengerOpen } = get();
				set({ isMessengerOpen: !isMessengerOpen });
			};

			return {
				...initialState,
				toggleMessenger,
			};
		},
		{
			name: 'app',
			partialize: (state) => ({ isMessengerOpen: state.isMessengerOpen }),
		},
	),
);

export default appStore;
